import { SVGProps } from 'react';

export type CircleStepProps = Pick<
  SVGProps<SVGSVGElement>,
  'fill' | 'children'
>;

export function CircleStep({ fill, children }: CircleStepProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      focusable='false'
      aria-hidden='true'
      viewBox='0 0 24 24'
    >
      <circle cx='12' cy='12' r='12' fill={fill} />
      <text
        x='12'
        y='12'
        textAnchor='middle'
        dominantBaseline='central'
        fill='#ffffff'
        fontWeight={600}
        fontSize='0.875rem'
      >
        {children}
      </text>
    </svg>
  );
}
